<template>
  <main id="seller-registration" class="site-main">
    <div class="grid-container">
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScsWlHfzs1fzcunwmsI5Z5cGo2DNXiT3hI1XZL26Js7yNz6DA/viewform?embedded=true" width="640" height="1710" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
    </div>
  </main>
</template>

<script>
import client from '@/mixins/client'
import authenticationMixin from '@/mixins/authentication'
import utils from '@/mixins/utils'

export default {
  name: 'sellerRegistration',
  mixins: [client, authenticationMixin, utils],
  components: {},
  created () {

  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

iframe {
  height: 1710px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/vendorPortal/sellerRegistration.vue